import { createContext, PropsWithChildren, useContext, useMemo } from "react";
import { type MondayContext as MondayContextType } from "frontend/canvas-page/cim-utils";
import { isCIM } from "utils/url-utils";

export const MondayContext = createContext<{
  mondayURL?: string;
  contextData?: MondayContextType;
  isCIM: boolean;
}>({
  mondayURL: undefined,
  contextData: undefined,
  isCIM: isCIM(),
});

type MondayProviderProps = {
  mondayURL?: string;
  contextData?: MondayContextType;
};

export const MondayProvider = ({ children, mondayURL, contextData }: PropsWithChildren<MondayProviderProps>) => {
  const value = useMemo(
    () => ({
      mondayURL,
      contextData,
      isCIM: isCIM(),
    }),
    [mondayURL, contextData]
  );
  return <MondayContext.Provider value={value}>{children}</MondayContext.Provider>;
};

export const useMondayContext = () => {
  const context = useContext(MondayContext);
  if (!context) {
    throw new Error("useMondayContext must be used within an MondayProvider");
  }
  return context;
};
